export default __webpack_public_path__ + "static/media/Canvera.3d77bfe5.webp";